import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const FooterPage = () => {
  const navigate = useNavigate();
  const baseUrl = import.meta.env.VITE_API_BASE_URL || "http://localhost:4000/api/v1";

  const [footer, setFooter] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const res = await axios.get(`${baseUrl}/footers`);
        setFooter(res.data?.data || {});
      } catch (err) {
        console.error("Error fetching footer:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchFooter();
  }, [baseUrl]);

  const handleStatusToggle = async (id: string, type: string) => {
    try {
      await axios.patch(`${baseUrl}/footers/toggle/${type}/${id}`);
      window.location.reload();
    } catch (err) {
      console.error("Toggle failed:", err);
    }
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm("Are you sure you want to delete this app?")) return;
    try {
      await axios.delete(`${baseUrl}/footers/app/${id}`);
      window.location.reload();
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  const handleEditFooter = (id: string) => navigate(`/settings/footer/edit/${id}`);
  const handleEditApp = (id: string) => navigate(`/settings/footer-app/edit/${id}`);
  const handleAddApp = () => navigate("/settings/footer-app/add");

  if (loading) return <p>Loading...</p>;
  if (!footer || Object.keys(footer).length === 0) return <p>No footer data found.</p>;

  return (
    <div className="side-app p-4">
      <div className="main-container container-fluid mb-5">
        <div className="page-header flex justify-between items-center mb-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active">Footer Details</li>
          </ol>
        </div>

        <div className="card table-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Title</th>
                    <th>Image</th>
                    <th>Get Link</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>{footer?.title}</td>
                    <td><img src={footer?.image || ""} alt="Footer" width="100" /></td>
                    <td>
                      <a href={footer?.link} target="_blank" rel="noreferrer">
                        {footer?.link}
                      </a>
                    </td>
                    <td>
                      <button
                        className={`badge ${footer?.status === "active" ? "bg-success" : "bg-danger"} text-white rounded-2`}
                        onClick={() => footer?._id && handleStatusToggle(footer._id, "footer")}
                      >
                        {footer?.status === "active" ? "Active" : "Inactive"}
                      </button>
                    </td>
                    <td>
                      <button
                        className="bg-primary-transparent text-primary p-2 rounded-2 fs-16 me-2"
                        onClick={() => footer?._id && handleEditFooter(footer._id)}
                      >
                        <i className="fe fe-edit"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container container-fluid">
        <div className="page-header flex justify-between items-center mb-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active">Footer Apps Section</li>
          </ol>

          <button className="btn btn-primary" onClick={handleAddApp}>
            <i className="icon-plus"></i> Add Footer App
          </button>
        </div>

        <div className="card table-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Image</th>
                    <th>App Link</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {footer.apps?.length > 0 ? (
                    footer.apps.map((app: any, i: number) => (
                      <tr key={app._id}>
                        <td>{i + 1}</td>
                        <td><img src={app?.image || ""} alt="App" width="100" /></td>
                        <td>
                          <a href={app?.link} target="_blank" rel="noreferrer">
                            {app?.link}
                          </a>
                        </td>
                        <td>
                          <button
                            className={`badge ${app?.status === "active" ? "bg-success" : "bg-danger"} text-white rounded-2`}
                            onClick={() => app?._id && handleStatusToggle(app._id, "app")}
                          >
                            {app?.status === "active" ? "Active" : "Inactive"}
                          </button>
                        </td>
                        <td>
                          <button
                            className="bg-primary-transparent text-primary p-2 rounded-2 fs-16 me-2"
                            onClick={() => app?._id && handleEditApp(app._id)}
                          >
                            <i className="fe fe-edit"></i>
                          </button>
                          <button
                            className="bg-danger-transparent text-danger p-2 rounded-2 fs-16"
                            onClick={() => app?._id && handleDelete(app._id)}
                          >
                            <i className="fe fe-trash-2"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">No footer apps found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterPage;
